export default __webpack_public_path__ + "static/media/BLZZ.01accd2d.svg";